const SessionEvent = {
  loginSuccess: 'session/login-success'
}

export default SessionEvent
